import React, { Component } from 'react';
import history from 'dashboard/history';
import AppsManager from 'lib/AppsManager';
import ParseApp from 'lib/ParseApp';
import PropTypes from 'prop-types';
import AppServerNotifcation from 'dashboard/AppServerNotifcation.react';

export default class AppData extends Component {
  constructor(props) {
    super(props);

    this.generatePath = this.generatePath.bind(this);

    this.state = {
    };
  }

  getChildContext() {
    return {
      generatePath: this.generatePath,
      currentApp: AppsManager.findAppBySlug(this.props.params.appId),
    };
  }

  generatePath(path) {
    return `/products/apps/${this.props.params.appId}/${path}`;
  }

  render() {
    const currentAppId = AppsManager.findAppBySlug(this.props.params.appId);

    if (currentAppId && !currentAppId.params.payment_needed) {
      currentAppId.setParseKeys();

      if (currentAppId.params.restoring_backup) {
        if (location.pathname !== `/products/apps/${currentAppId.slug}/db-restore`) {
          history.push(`/products/apps/${currentAppId.slug}/db-restore`);
          return <div />;
        }
      }
    }
    else {
      this.props.router.replace('/products/apps');
      return <div />;
    }

    const path = this.props.location.pathname.split('/')[3];

    if (currentAppId.server_status && currentAppId.server_status.state === 'finished' && path === 'creation') {
      this.props.router.replace(`/products/apps/${currentApp.slug}/`);
    }

    if (path === 'cloud_code' || path === 'creation') {
      return React.cloneElement(this.props.children, { ...this.props });
    }

    return <AppServerNotifcation {...this.props} />;
  }
}

AppData.childContextTypes = {
  generatePath: PropTypes.func,
  currentApp: PropTypes.instanceOf(ParseApp),
};
